import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { RootState } from "../store";
import logo from "@surgia/ui/icons/sidebar/logo.svg";
import patternUrl from "@surgia/ui/icons/backgrounds/pattern.svg";
import Button from "@surgia/ui/components/button";
import { useTranslation } from "react-i18next";

const LoginPage: React.FC = () => {
  const auth = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Access Redux global state for authentication
  const { globalState } = useSelector((state: RootState) => state.auth);
  const isReduxAuthenticated =
    globalState?.access_token && globalState?.subject_id;
  // Get the intended destination from navigation state
  const from = location.state?.from?.pathname || "/";
  useEffect(() => {
    // If user is authenticated (either via OIDC or Redux), redirect them
    if (auth.isAuthenticated || isReduxAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [auth.isAuthenticated, isReduxAuthenticated, navigate, from]);

  const handleSignIn = () => {
    // Store the intended destination before redirecting to Keycloak
    sessionStorage.setItem("redirectPath", from);
    auth.signinRedirect();
  };

  // Show loading state while checking authentication
  if (auth.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div
      className="relative min-h-screen flex items-center justify-center bg-white overflow-hidden"
      style={{
        backgroundImage: `url(${patternUrl})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <main className="relative z-10 flex flex-col items-center justify-center min-h-screen">
        <img
          src={logo}
          width={200}
          alt="Surgia Logo"
          style={{ maxWidth: "400px", height: "auto", aspectRatio: "256/83" }}
        />
        <Button
          onClick={handleSignIn}
          variant="ghost"
          className="cursor-pointer"
        >
          {t("shared.signIn")}
        </Button>
      </main>
    </div>
  );
};

export default LoginPage;
